import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { useData } from "../../hooks/useData";

// Animated FAQ accordion.
export default function FAQ() {
  const { data } = useData("faq");
  const [open, setOpen] = useState(0);
  if (!data) return null;

  return (
    <div className="mx-auto max-w-3xl space-y-3" data-testid="faq-list">
      {data.items.map((f, i) => {
        const active = open === i;
        return (
          <div key={i} className="overflow-hidden rounded-2xl glass" data-testid={`faq-item-${i}`}>
            <button
              onClick={() => setOpen(active ? -1 : i)}
              className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
              data-testid={`faq-question-${i}`}
            >
              <span className="font-medium text-slate-900">{f.q}</span>
              <motion.span animate={{ rotate: active ? 45 : 0 }} className="shrink-0 text-brand">
                <Plus size={20} />
              </motion.span>
            </button>
            <AnimatePresence initial={false}>
              {active && (
                <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.35 }}>
                  <p className="px-6 pb-5 text-sm text-slate-500">{f.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
